export type MessageSentimentLabel = 'positive' | 'negative' | 'neutral' | 'unknown';

export function getMessageSentimentLabel(value?: string): MessageSentimentLabel {
  const normalized = value?.trim().toLowerCase();
  if (normalized === 'positive' || normalized === 'negative' || normalized === 'neutral') {
    return normalized;
  }
  return 'unknown';
}

export function getMessageSentimentClass(value?: string): string {
  return `ca-msg__sentiment--${getMessageSentimentLabel(value)}`;
}

export function getMessageSentimentColor(value?: string): string {
  switch (getMessageSentimentLabel(value)) {
    case 'positive':
      return '#3b9a6b';
    case 'negative':
      return '#c13651';
    case 'neutral':
    case 'unknown':
      return '#b6b8ba';
  }
}

export function getMessageSentimentDisplayLabel(value?: string): string {
  const label = getMessageSentimentLabel(value);
  return label.replace(/^\w/, (letter) => letter.toUpperCase());
}

export function getMessageSentimentTooltip(value?: string): string {
  return `Sentiment: ${getMessageSentimentDisplayLabel(value)}`;
}
